module.exports = __webpack_public_path__ + "fonts/StagSans-Bold.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Bold.otf
// module id = 1094
// module chunks = 0